/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requested_Documents_LabelInputs */

const en_task_requested_documents_label = /** @type {(inputs: Task_Requested_Documents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested documents`)
};

const pt_br2_task_requested_documents_label = /** @type {(inputs: Task_Requested_Documents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos solicitados`)
};

/**
* | output |
* | --- |
* | "Requested documents" |
*
* @param {Task_Requested_Documents_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requested_documents_label = /** @type {((inputs?: Task_Requested_Documents_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requested_Documents_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requested_documents_label(inputs)
	return pt_br2_task_requested_documents_label(inputs)
});